module.exports = {
  l: '1rem', // 16px
  m: '0.75rem', // 12px
  s: '0.375rem', // 6px
  xs: '0.25rem', // 4px
};
